// Third party
import { configureStore } from '@reduxjs/toolkit';

// Middleware
import { default as middlewares } from 'middleware';

// Reducers
import { default as reducer } from 'reducers';


const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // disable the SerializableStateInvariantMiddleware because it seems to slow down dev and is disable on production build
      serializableCheck: false, 
    }).concat(...middlewares),
});
export default store;
